import styled from "styled-components";

const TableRow = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;

  .CellName {
    width: calc(54.72% - 64px);
  }

  .CellValueOne {
    width: calc(22.64% - 24px);
    margin-left: 64px;
    flex-shrink: 0;
  }

  .CellValueTwo {
    width: calc(22.64% - 24px);
    margin-left: 48px;
    flex-shrink: 0;
  }

  .CellSupValue {
    margin-top: 4px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    .CellName {
      width: calc(40% - 64px);
    }

    .CellValueOne,
    .CellValueTwo {
      width: calc(30% - 24px);
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .CellName {
      width: calc(47.16% - 64px);
    }

    .CellValueOne,
    .CellValueTwo {
      width: calc(26.42% - 24px);
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .CellName {
      flex-shrink: 1;
      width: calc(43.73% - 16px);
    }

    .CellValueOne,
    .CellValueTwo {
      flex-shrink: 1;
      width: calc(28.135% - 8px);
      margin-left: 16px;
    }
  }
`;

export { TableRow };
